import React, { useMemo, useState } from "react";
import { DayPicker } from "react-day-picker";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { format, isBefore, startOfDay } from "date-fns";
import "react-day-picker/dist/style.css";
import "./calendar.css";

import { Typography } from "@mui/material";

const ChevronLeft = (props) => <ChevronLeftIcon {...props} />;
const ChevronRight = (props) => <ChevronRightIcon {...props} />;

const CalendarCard = ({ selected, setSelected }) => {
  const [month, setMonth] = useState(selected || new Date());

  // Keep month in sync if selected changes from outside
  React.useEffect(() => {
    if (selected) setMonth(selected);
  }, []);

  const today = startOfDay(new Date());

  // Disable past dates
  const isDisabled = (date) => isBefore(startOfDay(date), today);

  return (
    <div className="calendar-shell">
      <div className="calendar-header">
        <Typography variant="h4">{format(month, "MMMM yyyy")}</Typography>

        <div className="calendar-nav">
          <button
            type="button"
            onClick={() =>
              setMonth(
                (prev) => new Date(prev.getFullYear(), prev.getMonth() - 1),
              )
            }
          >
            <ChevronLeft size={18} />
          </button>

          <button
            type="button"
            onClick={() =>
              setMonth(
                (prev) => new Date(prev.getFullYear(), prev.getMonth() + 1),
              )
            }
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>

      <DayPicker
        mode="single"
        month={month}
        selected={selected}
        onSelect={setSelected}
        onMonthChange={setMonth}
        disabled={isDisabled}
        showOutsideDays={false}
        hideNavigation
        className="custom-calendar"
      />
    </div>
  );
};

export default CalendarCard;
